import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BlobService {
  getImageBlob(data: string): Blob {
    const contentType = 'image/png';
    const newData = data.replace(/^data:image\/(png|jpeg|jpg);base64,/, '');
    return this.getBlobData(newData, contentType);
  }

  getBlobData(b64Data: string, contentType = '', sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
}
